export enum Withholding {
	Federal = 1,
	State = 2,
	SocialSecurity = 3,
	Medicare = 4,
	Retirement = 5,
	FUTA = 6,
	SUTA = 7,
	Other = 8,
}
